<!-- old dashboard -->
<div class="content container-fluid pb-0 d-none">
  <div class="page-header">
    <div class="row">
      <div class="col-sm-12">
        <h3 class="page-title">Welcome Admin!</h3>
        <ul class="breadcrumb">
          <li class="breadcrumb-item active">Dashboard</li>
        </ul>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-9 d-none">
          <div class="row">
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
              <div class="card dash-widget">
                <div class="card-body">
                  <span class="dash-widget-icon"><i class="fa-solid fa-cubes"></i></span>
                  <div class="dash-widget-info">
                    <h3>112</h3>
                    <span>Projects</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
              <div class="card dash-widget">
                <div class="card-body">
                  <span class="dash-widget-icon"><i class="fa-solid fa-dollar-sign"></i></span>
                  <div class="dash-widget-info">
                    <h3>44</h3>
                    <span>Clients</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
              <div class="card dash-widget">
                <div class="card-body">
                  <span class="dash-widget-icon"><i class="fa-regular fa-gem"></i></span>
                  <div class="dash-widget-info">
                    <h3>37</h3>
                    <span>Tasks</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
              <div class="card dash-widget">
                <div class="card-body">
                  <span class="dash-widget-icon"><i class="fa-solid fa-user"></i></span>
                  <div class="dash-widget-info">
                    <h3>218</h3>
                    <span>Employees</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-md-4"
          *ngIf="
            ![
              'Admin',
              'Business Owner',
              'Business',
              'Admin User',
              'BusinessOwnerAdminUser',
              'User',
              'BusinessAdminUser',
              'Office'
            ].includes(user?.role.name)
          "
        >
          <div class="card punch-status">
            <div class="card-body">
              <h5 class="card-title">
                Timesheet: <small class="text-muted">{{ todayDate }}</small>
              </h5>
              <div class="punch-det" *ngIf="isPunchedIn; else punchedOuts">
                <h6>Clock In at</h6>
                <p>{{ punchInTime | date: 'EEE, MMM dd, yyyy, hh:mm a' }}</p>
              </div>

              <ng-template #punchedOuts>
                <div class="punch-det">
                  <h6>Clock Out at</h6>
                  <p>{{ punchOutTime | date: 'EEE, MMM dd, yyyy, hh:mm a' }}</p>
                </div>
              </ng-template>
              <div class="punch-info">
                <div class="punch-hours">
                  <!-- Check if totalWorkedHours is available -->
                  <span *ngIf="gpsWorkedMinutes; else noPunchTime"
                    >{{ gpsWorkedHours }} H {{ gpsWorkedMinutes }} Min</span
                  >

                  <!-- Fallback if totalWorkedHours is not available -->
                  <ng-template #noPunchTime>
                    <span>0 H 0 Min</span>
                  </ng-template>
                </div>
              </div>
              <!-- <div class="punch-btn-section">
                  <button type="button" class="btn btn-primary punch-btn" (click)="punch()">Punch Out</button>
                </div> -->

              <div class="punch-btn-section" *ngIf="isPunchedIn; else punchedOut">
                <!-- <p>You punched in at: {{ punchInTime | date: 'short' }}</p> -->
                <button type="button" class="btn btn-primary punch-btn" (click)="punchOut()">
                  Clock Out
                </button>
              </div>

              <ng-template #punchedOut>
                <div class="punch-btn-section">
                  <!-- <p>You punched out at: {{ punchOutTime | date: 'short' }}</p> -->
                  <button type="button" class="btn btn-primary punch-btn" (click)="punchIn()">
                    Clock In
                  </button>
                </div>
              </ng-template>
              <div class="statistics d-none">
                <div class="row">
                  <div class="col-md-6 col-6 text-center">
                    <div class="stats-box">
                      <p>Break</p>
                      <h6>1.21 hrs</h6>
                    </div>
                  </div>
                  <div class="col-md-6 col-6 text-center">
                    <div class="stats-box">
                      <p>Overtime</p>
                      <h6>3 hrs</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row d-none">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-6 text-center">
          <div class="card">
            <div class="card-body">
              <h3 class="card-title">Total Revenue</h3>
              <div id="bar-charts"></div>
            </div>
          </div>
        </div>
        <div class="col-md-6 text-center">
          <div class="card">
            <div class="card-body">
              <h3 class="card-title">Sales Overview</h3>
              <div id="line-charts"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row d-none">
    <div class="col-md-12">
      <div class="card-group m-b-30">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between mb-3">
              <div>
                <span class="d-block">New Employees</span>
              </div>
              <div>
                <span class="text-success">+10%</span>
              </div>
            </div>
            <h3 class="mb-3">10</h3>
            <div class="progress height-five mb-2">
              <div
                class="progress-bar bg-primary w-70"
                role="progressbar"
                aria-valuenow="40"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <p class="mb-0">Overall Employees 218</p>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between mb-3">
              <div>
                <span class="d-block">Earnings</span>
              </div>
              <div>
                <span class="text-success">+12.5%</span>
              </div>
            </div>
            <h3 class="mb-3">$1,42,300</h3>
            <div class="progress height-five mb-2">
              <div
                class="progress-bar bg-primary w-70"
                role="progressbar"
                aria-valuenow="40"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <p class="mb-0">Previous Month <span class="text-muted">$1,15,852</span></p>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between mb-3">
              <div>
                <span class="d-block">Expenses</span>
              </div>
              <div>
                <span class="text-danger">-2.8%</span>
              </div>
            </div>
            <h3 class="mb-3">$8,500</h3>
            <div class="progress height-five mb-2">
              <div
                class="progress-bar bg-primary w-70"
                role="progressbar"
                aria-valuenow="40"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <p class="mb-0">Previous Month <span class="text-muted">$7,500</span></p>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between mb-3">
              <div>
                <span class="d-block">Profit</span>
              </div>
              <div>
                <span class="text-danger">-75%</span>
              </div>
            </div>
            <h3 class="mb-3">$1,12,000</h3>
            <div class="progress height-five mb-2">
              <div
                class="progress-bar bg-primary w-70"
                role="progressbar"
                aria-valuenow="40"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <p class="mb-0">Previous Month <span class="text-muted">$1,42,000</span></p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row d-none">
    <div class="col-md-12 col-lg-12 col-xl-4 d-flex">
      <div class="card flex-fill dash-statistics">
        <div class="card-body">
          <h5 class="card-title">Statistics</h5>
          <div class="stats-list">
            <div class="stats-info">
              <p>
                Today Leave <strong>4 <small>/ 65</small></strong>
              </p>
              <div class="progress">
                <div
                  class="progress-bar bg-primary w-31"
                  role="progressbar"
                  aria-valuenow="31"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
            <div class="stats-info">
              <p>
                Pending Invoice <strong>15 <small>/ 92</small></strong>
              </p>
              <div class="progress">
                <div
                  class="progress-bar bg-warning w-31"
                  role="progressbar"
                  aria-valuenow="31"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
            <div class="stats-info">
              <p>
                Completed Projects <strong>85 <small>/ 112</small></strong>
              </p>
              <div class="progress">
                <div
                  class="progress-bar bg-success w-62"
                  role="progressbar"
                  aria-valuenow="62"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
            <div class="stats-info">
              <p>
                Open Tickets <strong>190 <small>/ 212</small></strong>
              </p>
              <div class="progress">
                <div
                  class="progress-bar bg-danger w-62"
                  role="progressbar"
                  aria-valuenow="62"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
            <div class="stats-info">
              <p>
                Closed Tickets <strong>22 <small>/ 212</small></strong>
              </p>
              <div class="progress">
                <div
                  class="progress-bar bg-info w-22"
                  role="progressbar"
                  aria-valuenow="22"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-6 col-xl-4 d-flex">
      <div class="card flex-fill">
        <div class="card-body">
          <h4 class="card-title">Task Statistics</h4>
          <div class="statistics">
            <div class="row">
              <div class="col-md-6 col-6 text-center">
                <div class="stats-box mb-4">
                  <p>Total Tasks</p>
                  <h3>385</h3>
                </div>
              </div>
              <div class="col-md-6 col-6 text-center">
                <div class="stats-box mb-4">
                  <p>Overdue Tasks</p>
                  <h3>19</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="progress mb-4">
            <div
              class="progress-bar bg-purple w-30"
              role="progressbar"
              aria-valuenow="30"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              30%
            </div>
            <div
              class="progress-bar bg-warning w-22"
              role="progressbar"
              aria-valuenow="18"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              22%
            </div>
            <div
              class="progress-bar bg-success w-24"
              role="progressbar"
              aria-valuenow="12"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              24%
            </div>
            <div
              class="progress-bar bg-danger w-21"
              role="progressbar"
              aria-valuenow="14"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              21%
            </div>
            <div
              class="progress-bar bg-info w-10"
              role="progressbar"
              aria-valuenow="14"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              10%
            </div>
          </div>
          <div>
            <p>
              <i class="fa-regular fa-circle-dot text-purple me-2"></i>Completed Tasks
              <span class="float-end">166</span>
            </p>
            <p>
              <i class="fa-regular fa-circle-dot text-warning me-2"></i>Inprogress Tasks
              <span class="float-end">115</span>
            </p>
            <p>
              <i class="fa-regular fa-circle-dot text-success me-2"></i>On Hold Tasks
              <span class="float-end">31</span>
            </p>
            <p>
              <i class="fa-regular fa-circle-dot text-danger me-2"></i>Pending Tasks
              <span class="float-end">47</span>
            </p>
            <p class="mb-0">
              <i class="fa-regular fa-circle-dot text-info me-2"></i>Review Tasks
              <span class="float-end">5</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-6 col-xl-4 d-flex">
      <div class="card flex-fill">
        <div class="card-body">
          <h4 class="card-title">
            Today Absent <span class="badge bg-inverse-danger ms-2">5</span>
          </h4>
          <div class="leave-info-box">
            <div class="media d-flex align-items-center">
              <a href="profile.html" class="avatar"
                ><img src="../../../../assets/img/user.jpg" alt="User Image"
              /></a>
              <div class="media-body flex-grow-1">
                <div class="text-sm my-0">Martin Lewis</div>
              </div>
            </div>
            <div class="row align-items-center mt-3">
              <div class="col-6">
                <h6 class="mb-0">4 Sep 2019</h6>
                <span class="text-sm text-muted">Leave Date</span>
              </div>
              <div class="col-6 text-end">
                <span class="badge bg-inverse-danger">Pending</span>
              </div>
            </div>
          </div>
          <div class="leave-info-box">
            <div class="media d-flex align-items-center">
              <a href="profile.html" class="avatar"
                ><img src="../../../../assets/img/user.jpg" alt="User Image"
              /></a>
              <div class="media-body flex-grow-1">
                <div class="text-sm my-0">Martin Lewis</div>
              </div>
            </div>
            <div class="row align-items-center mt-3">
              <div class="col-6">
                <h6 class="mb-0">4 Sep 2019</h6>
                <span class="text-sm text-muted">Leave Date</span>
              </div>
              <div class="col-6 text-end">
                <span class="badge bg-inverse-success">Approved</span>
              </div>
            </div>
          </div>
          <div class="load-more text-center">
            <a class="text-dark" href="javascript:void(0);">Load More</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row d-none">
    <div class="col-md-6 d-flex">
      <div class="card card-table flex-fill">
        <div class="card-header">
          <h3 class="card-title mb-0">Invoices</h3>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-nowrap custom-table mb-0">
              <thead>
                <tr>
                  <th>Invoice ID</th>
                  <th>Client</th>
                  <th>Due Date</th>
                  <th>Total</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><a href="invoice-view.html">#INV-0001</a></td>
                  <td>
                    <h2><a href="#">Global Technologies</a></h2>
                  </td>
                  <td>11 Mar 2019</td>
                  <td>$380</td>
                  <td>
                    <span class="badge bg-inverse-warning">Partially Paid</span>
                  </td>
                </tr>
                <tr>
                  <td><a href="invoice-view.html">#INV-0002</a></td>
                  <td>
                    <h2><a href="#">Delta Infotech</a></h2>
                  </td>
                  <td>8 Feb 2019</td>
                  <td>$500</td>
                  <td>
                    <span class="badge bg-inverse-success">Paid</span>
                  </td>
                </tr>
                <tr>
                  <td><a href="invoice-view.html">#INV-0003</a></td>
                  <td>
                    <h2><a href="#">Cream Inc</a></h2>
                  </td>
                  <td>23 Jan 2019</td>
                  <td>$60</td>
                  <td>
                    <span class="badge bg-inverse-danger">Unpaid</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card-footer">
          <a href="invoices.html">View all invoices</a>
        </div>
      </div>
    </div>
    <div class="col-md-6 d-flex">
      <div class="card card-table flex-fill">
        <div class="card-header">
          <h3 class="card-title mb-0">Payments</h3>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table custom-table table-nowrap mb-0">
              <thead>
                <tr>
                  <th>Invoice ID</th>
                  <th>Client</th>
                  <th>Payment Type</th>
                  <th>Paid Date</th>
                  <th>Paid Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><a href="invoice-view.html">#INV-0001</a></td>
                  <td>
                    <h2><a href="#">Global Technologies</a></h2>
                  </td>
                  <td>Paypal</td>
                  <td>11 Mar 2019</td>
                  <td>$380</td>
                </tr>
                <tr>
                  <td><a href="invoice-view.html">#INV-0002</a></td>
                  <td>
                    <h2><a href="#">Delta Infotech</a></h2>
                  </td>
                  <td>Paypal</td>
                  <td>8 Feb 2019</td>
                  <td>$500</td>
                </tr>
                <tr>
                  <td><a href="invoice-view.html">#INV-0003</a></td>
                  <td>
                    <h2><a href="#">Cream Inc</a></h2>
                  </td>
                  <td>Paypal</td>
                  <td>23 Jan 2019</td>
                  <td>$60</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card-footer">
          <a href="payments.html">View all payments</a>
        </div>
      </div>
    </div>
  </div>
  <div class="row d-none">
    <div class="col-md-6 d-flex">
      <div class="card card-table flex-fill">
        <div class="card-header">
          <h3 class="card-title mb-0">Clients</h3>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table custom-table mb-0">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th class="text-end">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <h2 class="table-avatar">
                      <a href="#" class="avatar"
                        ><img src="../../../../assets/img/profiles/avatar-19.jpg" alt="User Image"
                      /></a>
                      <a href="client-profile.html">Barry Cuda <span>CEO</span></a>
                    </h2>
                  </td>
                  <td>
                    <a
                      href="https://avrtechno.com/cdn-cgi/l/email-protection"
                      class="__cf_email__"
                      data-cfemail="f5979487878c96809194b5908d9498859990db969a98"
                      >[email&#160;protected]</a
                    >
                  </td>
                  <td>
                    <div class="dropdown action-label">
                      <a
                        class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                        href="#"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i class="fa-regular fa-circle-dot text-success"></i> Active
                      </a>
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="#"
                          ><i class="fa-regular fa-circle-dot text-success"></i> Active</a
                        >
                        <a class="dropdown-item" href="#"
                          ><i class="fa-regular fa-circle-dot text-danger"></i> Inactive</a
                        >
                      </div>
                    </div>
                  </td>
                  <td class="text-end">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-solid fa-pencil m-r-5"></i> Edit</a
                        >
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h2 class="table-avatar">
                      <a href="#" class="avatar"
                        ><img src="../../../../assets/img/profiles/avatar-19.jpg" alt="User Image"
                      /></a>
                      <a href="client-profile.html">Tressa Wexler <span>Manager</span></a>
                    </h2>
                  </td>
                  <td>
                    <a
                      href="https://avrtechno.com/cdn-cgi/l/email-protection"
                      class="__cf_email__"
                      data-cfemail="8afef8eff9f9ebfdeff2e6eff8caeff2ebe7fae6efa4e9e5e7"
                      >[email&#160;protected]</a
                    >
                  </td>
                  <td>
                    <div class="dropdown action-label">
                      <a
                        class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                        href="#"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i class="fa-regular fa-circle-dot text-danger"></i> Inactive
                      </a>
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="#"
                          ><i class="fa-regular fa-circle-dot text-success"></i> Active</a
                        >
                        <a class="dropdown-item" href="#"
                          ><i class="fa-regular fa-circle-dot text-danger"></i> Inactive</a
                        >
                      </div>
                    </div>
                  </td>
                  <td class="text-end">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-solid fa-pencil m-r-5"></i> Edit</a
                        >
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h2 class="table-avatar">
                      <a href="client-profile.html" class="avatar"
                        ><img src="../../../../assets/img/profiles/avatar-07.jpg" alt="User Image"
                      /></a>
                      <a href="client-profile.html">Ruby Bartlett <span>CEO</span></a>
                    </h2>
                  </td>
                  <td>
                    <a
                      href="https://avrtechno.com/cdn-cgi/l/email-protection"
                      class="__cf_email__"
                      data-cfemail="ff8d8a9d869d9e8d8b939a8b8bbf9a879e928f939ad19c9092"
                      >[email&#160;protected]</a
                    >
                  </td>
                  <td>
                    <div class="dropdown action-label">
                      <a
                        class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                        href="#"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i class="fa-regular fa-circle-dot text-danger"></i> Inactive
                      </a>
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="#"
                          ><i class="fa-regular fa-circle-dot text-success"></i> Active</a
                        >
                        <a class="dropdown-item" href="#"
                          ><i class="fa-regular fa-circle-dot text-danger"></i> Inactive</a
                        >
                      </div>
                    </div>
                  </td>
                  <td class="text-end">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-solid fa-pencil m-r-5"></i> Edit</a
                        >
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h2 class="table-avatar">
                      <a href="client-profile.html" class="avatar"
                        ><img src="../../../../assets/img/profiles/avatar-06.jpg" alt="User Image"
                      /></a>
                      <a href="client-profile.html"> Misty Tison <span>CEO</span></a>
                    </h2>
                  </td>
                  <td>
                    <a
                      href="https://avrtechno.com/cdn-cgi/l/email-protection"
                      class="__cf_email__"
                      data-cfemail="9bf6f2e8efe2eff2e8f4f5dbfee3faf6ebf7feb5f8f4f6"
                      >[email&#160;protected]</a
                    >
                  </td>
                  <td>
                    <div class="dropdown action-label">
                      <a
                        class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                        href="#"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i class="fa-regular fa-circle-dot text-success"></i> Active
                      </a>
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="#"
                          ><i class="fa-regular fa-circle-dot text-success"></i> Active</a
                        >
                        <a class="dropdown-item" href="#"
                          ><i class="fa-regular fa-circle-dot text-danger"></i> Inactive</a
                        >
                      </div>
                    </div>
                  </td>
                  <td class="text-end">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-solid fa-pencil m-r-5"></i> Edit</a
                        >
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h2 class="table-avatar">
                      <a href="client-profile.html" class="avatar"
                        ><img src="../../../../assets/img/profiles/avatar-14.jpg" alt="User Image"
                      /></a>
                      <a href="client-profile.html"> Daniel Deacon <span>CEO</span></a>
                    </h2>
                  </td>
                  <td>
                    <a
                      href="https://avrtechno.com/cdn-cgi/l/email-protection"
                      class="__cf_email__"
                      data-cfemail="ddb9bcb3b4b8b1b9b8bcbeb2b39db8a5bcb0adb1b8f3beb2b0"
                      >[email&#160;protected]</a
                    >
                  </td>
                  <td>
                    <div class="dropdown action-label">
                      <a
                        class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                        href="#"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i class="fa-regular fa-circle-dot text-danger"></i> Inactive
                      </a>
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="#"
                          ><i class="fa-regular fa-circle-dot text-success"></i> Active</a
                        >
                        <a class="dropdown-item" href="#"
                          ><i class="fa-regular fa-circle-dot text-danger"></i> Inactive</a
                        >
                      </div>
                    </div>
                  </td>
                  <td class="text-end">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-solid fa-pencil m-r-5"></i> Edit</a
                        >
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card-footer">
          <a href="clients.html">View all clients</a>
        </div>
      </div>
    </div>
    <div class="col-md-6 d-flex">
      <div class="card card-table flex-fill">
        <div class="card-header">
          <h3 class="card-title mb-0">Recent Projects</h3>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table custom-table mb-0">
              <thead>
                <tr>
                  <th>Project Name</th>
                  <th>Progress</th>
                  <th class="text-end">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <h2><a href="project-view.html">Office Management</a></h2>
                    <small class="block text-ellipsis">
                      <span>1</span> <span class="text-muted">open tasks, </span> <span>9</span>
                      <span class="text-muted">tasks completed</span>
                    </small>
                  </td>
                  <td>
                    <div class="progress progress-xs progress-striped">
                      <div
                        class="progress-bar w-65"
                        role="progressbar"
                        data-bs-toggle="tooltip"
                        title="65%"
                      ></div>
                    </div>
                  </td>
                  <td class="text-end">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-solid fa-pencil m-r-5"></i> Edit</a
                        >
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h2><a href="project-view.html">Project Management</a></h2>
                    <small class="block text-ellipsis">
                      <span>2</span> <span class="text-muted">open tasks, </span> <span>5</span>
                      <span class="text-muted">tasks completed</span>
                    </small>
                  </td>
                  <td>
                    <div class="progress progress-xs progress-striped">
                      <div
                        class="progress-bar w-15"
                        role="progressbar"
                        data-bs-toggle="tooltip"
                        title="15%"
                      ></div>
                    </div>
                  </td>
                  <td class="text-end">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-solid fa-pencil m-r-5"></i> Edit</a
                        >
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h2><a href="project-view.html">Video Calling App</a></h2>
                    <small class="block text-ellipsis">
                      <span>3</span> <span class="text-muted">open tasks, </span> <span>3</span>
                      <span class="text-muted">tasks completed</span>
                    </small>
                  </td>
                  <td>
                    <div class="progress progress-xs progress-striped">
                      <div
                        class="progress-bar w-50"
                        role="progressbar"
                        data-bs-toggle="tooltip"
                        title="50%"
                      ></div>
                    </div>
                  </td>
                  <td class="text-end">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-solid fa-pencil m-r-5"></i> Edit</a
                        >
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h2><a href="project-view.html">Hospital Administration</a></h2>
                    <small class="block text-ellipsis">
                      <span>12</span> <span class="text-muted">open tasks, </span> <span>4</span>
                      <span class="text-muted">tasks completed</span>
                    </small>
                  </td>
                  <td>
                    <div class="progress progress-xs progress-striped">
                      <div
                        class="progress-bar w-88"
                        role="progressbar"
                        data-bs-toggle="tooltip"
                        title="88%"
                      ></div>
                    </div>
                  </td>
                  <td class="text-end">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-solid fa-pencil m-r-5"></i> Edit</a
                        >
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h2><a href="project-view.html">Digital Marketplace</a></h2>
                    <small class="block text-ellipsis">
                      <span>7</span> <span class="text-muted">open tasks, </span> <span>14</span>
                      <span class="text-muted">tasks completed</span>
                    </small>
                  </td>
                  <td>
                    <div class="progress progress-xs progress-striped">
                      <div
                        class="progress-bar w-100"
                        role="progressbar"
                        data-bs-toggle="tooltip"
                        title="100%"
                      ></div>
                    </div>
                  </td>
                  <td class="text-end">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-solid fa-pencil m-r-5"></i> Edit</a
                        >
                        <a class="dropdown-item" href="javascript:void(0)"
                          ><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card-footer">
          <a href="projects.html">View all projects</a>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- old dashboard end -->

<!-- Page Wrapper -->
<div class="page-wrapper" style="margin-left: 5px !important">
  <div class="content">
    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <div class="my-auto mb-2">
        <h2 class="mb-1">Admin Dashboard</h2>
        <nav>
          <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item">
              <a [routerLink]="['/user/dashboard']"><i class="ti ti-smart-home"></i></a>
            </li>
            <li class="breadcrumb-item">Dashboard</li>
            <li class="breadcrumb-item active" aria-current="page">Admin Dashboard</li>
          </ol>
        </nav>
      </div>

      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
        <div class="me-2 mb-2">
          <div class="dropdown">
            <a
              href="javascript:void(0);"
              class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
              data-bs-toggle="dropdown"
            >
              <i class="ti ti-file-export me-1"></i>Export
            </a>
            <ul class="dropdown-menu dropdown-menu-end p-3">
              <li>
                <a href="javascript:void(0);" class="dropdown-item rounded-1"
                  ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
                >
              </li>
              <li>
                <a href="javascript:void(0);" class="dropdown-item rounded-1"
                  ><i class="ti ti-file-type-xls me-1"></i>Export as Excel
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="mb-2">
          <div class="input-icon w-120 position-relative">
            <span class="input-icon-addon">
              <i class="ti ti-calendar text-gray-9"></i>
            </span>
            <input type="text" class="form-control yearpicker" value="2025" />
          </div>
        </div>
        <div class="ms-2 head-icons">
          <a
            href="javascript:void(0);"
            class=""
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-original-title="Collapse"
            id="collapse-header"
          >
            <i class="ti ti-chevrons-up"></i>
          </a>
        </div>
      </div>
    </div>
    <!-- /Breadcrumb -->

    <!-- Welcome Wrap -->
    <div class="card border-0">
      <div class="card-body d-flex align-items-center justify-content-between flex-wrap pb-1">
        <div class="d-flex align-items-center mb-3">
          <span class="avatar avatar-xl flex-shrink-0">
            <img src="assets/img/profiles/avatar-31.jpg" class="rounded-circle" alt="img" />
          </span>
          <div class="ms-3">
            <h3 class="mb-2">
              Welcome Back, Adrian
              <a href="javascript:void(0);" class="edit-icon"><i class="ti ti-edit fs-14"></i></a>
            </h3>
            <p>
              You have <span class="text-primary text-decoration-underline">21</span> Pending
              Approvals & <span class="text-primary text-decoration-underline">14</span> Leave
              Requests
            </p>
          </div>
        </div>
        <div class="d-flex align-items-center flex-wrap mb-1">
          <a
            href="#"
            class="btn btn-secondary btn-md me-2 mb-2"
            data-bs-toggle="modal"
            data-bs-target="#add_project"
            ><i class="ti ti-square-rounded-plus me-1"></i>Add Project</a
          >
          <a
            href="#"
            class="btn btn-primary btn-md mb-2"
            data-bs-toggle="modal"
            data-bs-target="#add_leaves"
            ><i class="ti ti-square-rounded-plus me-1"></i>Add Requests</a
          >
        </div>
      </div>
    </div>
    <!-- /Welcome Wrap -->

    <div class="row">
      <!-- Widget Info -->
      <div class="col-xxl-8 d-flex">
        <div class="row flex-fill">
          <div class="col-md-3 d-flex">
            <div class="card flex-fill">
              <div class="card-body">
                <span class="avatar rounded-circle bg-primary mb-2">
                  <i class="ti ti-calendar-share fs-16"></i>
                </span>
                <h6 class="fs-13 fw-medium text-default mb-1">Attendance Overview</h6>
                <h3 class="mb-3">
                  120/154
                  <span class="fs-12 fw-medium text-success"
                    ><i class="fa-solid fa-caret-up me-1"></i>+2.1%</span
                  >
                </h3>
                <a href="attendance-employee.html" class="link-default">View Details</a>
              </div>
            </div>
          </div>
          <div class="col-md-3 d-flex">
            <div class="card flex-fill">
              <div class="card-body">
                <span class="avatar rounded-circle bg-secondary mb-2">
                  <i class="ti ti-browser fs-16"></i>
                </span>
                <h6 class="fs-13 fw-medium text-default mb-1">Total No of Project's</h6>
                <h3 class="mb-3">
                  90/125
                  <span class="fs-12 fw-medium text-danger"
                    ><i class="fa-solid fa-caret-down me-1"></i>-2.1%</span
                  >
                </h3>
                <a href="projects.html" class="link-default">View All</a>
              </div>
            </div>
          </div>
          <div class="col-md-3 d-flex">
            <div class="card flex-fill">
              <div class="card-body">
                <span class="avatar rounded-circle bg-info mb-2">
                  <i class="ti ti-users-group fs-16"></i>
                </span>
                <h6 class="fs-13 fw-medium text-default mb-1">Total No of Clients</h6>
                <h3 class="mb-3">
                  69/86
                  <span class="fs-12 fw-medium text-danger"
                    ><i class="fa-solid fa-caret-down me-1"></i>-11.2%</span
                  >
                </h3>
                <a href="clients.html" class="link-default">View All</a>
              </div>
            </div>
          </div>
          <div class="col-md-3 d-flex">
            <div class="card flex-fill">
              <div class="card-body">
                <span class="avatar rounded-circle bg-pink mb-2">
                  <i class="ti ti-checklist fs-16"></i>
                </span>
                <h6 class="fs-13 fw-medium text-default mb-1">Total No of Tasks</h6>
                <h3 class="mb-3">
                  225/28
                  <span class="fs-12 fw-medium text-success"
                    ><i class="fa-solid fa-caret-down me-1"></i>+11.2%</span
                  >
                </h3>
                <a href="tasks.html" class="link-default">View All</a>
              </div>
            </div>
          </div>
          <div class="col-md-3 d-flex">
            <div class="card flex-fill">
              <div class="card-body">
                <span class="avatar rounded-circle bg-purple mb-2">
                  <i class="ti ti-moneybag fs-16"></i>
                </span>
                <h6 class="fs-13 fw-medium text-default mb-1">Earnings</h6>
                <h3 class="mb-3">
                  $21445
                  <span class="fs-12 fw-medium text-success"
                    ><i class="fa-solid fa-caret-up me-1"></i>+10.2%</span
                  >
                </h3>
                <a href="expenses.html" class="link-default">View All</a>
              </div>
            </div>
          </div>
          <div class="col-md-3 d-flex">
            <div class="card flex-fill">
              <div class="card-body">
                <span class="avatar rounded-circle bg-danger mb-2">
                  <i class="ti ti-browser fs-16"></i>
                </span>
                <h6 class="fs-13 fw-medium text-default mb-1">Profit This Week</h6>
                <h3 class="mb-3">
                  $5,544
                  <span class="fs-12 fw-medium text-success"
                    ><i class="fa-solid fa-caret-up me-1"></i>+2.1%</span
                  >
                </h3>
                <a href="purchase-transaction.html" class="link-default">View All</a>
              </div>
            </div>
          </div>
          <div class="col-md-3 d-flex">
            <div class="card flex-fill">
              <div class="card-body">
                <span class="avatar rounded-circle bg-success mb-2">
                  <i class="ti ti-users-group fs-16"></i>
                </span>
                <h6 class="fs-13 fw-medium text-default mb-1">Job Applicants</h6>
                <h3 class="mb-3">
                  98
                  <span class="fs-12 fw-medium text-success"
                    ><i class="fa-solid fa-caret-up me-1"></i>+2.1%</span
                  >
                </h3>
                <a href="job-list.html" class="link-default">View All</a>
              </div>
            </div>
          </div>
          <div class="col-md-3 d-flex">
            <div class="card flex-fill">
              <div class="card-body">
                <span class="avatar rounded-circle bg-dark mb-2">
                  <i class="ti ti-user-star fs-16"></i>
                </span>
                <h6 class="fs-13 fw-medium text-default mb-1">New Hire</h6>
                <h3 class="mb-3">
                  45/48
                  <span class="fs-12 fw-medium text-danger"
                    ><i class="fa-solid fa-caret-down me-1"></i>-11.2%</span
                  >
                </h3>
                <a href="candidates.html" class="link-default">View All</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Widget Info -->

      <!-- Anniversary -->
      <div class="col-xxl-4 col-xl-6 d-flex align-items-start">
        <div class="card flex-fill">
          <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
            <h5 class="mb-2">Work Anniversaries</h5>
            <a
              *ngIf="
                todayAnniversaries.length !== 0 ||
                tomorrowAnniversaries.length !== 0 ||
                upcomingAnniversaries.length !== 0
              "
              [routerLink]="eps.event.anniversaryPath"
              class="btn btn-light btn-md mb-2"
              >View All</a
            >
          </div>
          <ng-container
            *ngIf="
              todayAnniversaries.length !== 0 ||
                tomorrowAnniversaries.length !== 0 ||
                upcomingAnniversaries.length !== 0;
              else noRecords
            "
          >
            <div class="card-body pb-1">
              <!-- ================= TODAY ================= -->
              <h6 *ngIf="todayAnniversaries.length !== 0" class="mb-2">Today</h6>

              <div
                *ngFor="let user of todayAnniversaries"
                class="bg-light p-2 border border-dashed rounded-top mb-3"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <span class="avatar">
                      <ng-container *ngIf="user.picture; else noAvatar">
                        <img
                          [src]="apiEndpoint + '/uploads/' + user.picture"
                          class="rounded-circle border border-2"
                          alt="img"
                        />
                      </ng-container>

                      <ng-template #noAvatar>
                        <span
                          class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                          style="width: 32px; height: 32px"
                        >
                          {{ user.firstName.charAt(0) }}
                        </span>
                      </ng-template>
                    </span>

                    <div class="ms-2 overflow-hidden">
                      <h6 class="fs-medium">{{ user.firstName }} {{ user.lastName }}</h6>
                      <p class="fs-13">{{ user.designation?.designationName || '—' }}</p>
                    </div>
                  </div>

                  <button class="btn btn-success btn-xs">
                    <i class="ti ti-confetti me-1"></i>Wish
                  </button>
                </div>
              </div>

              <!-- ================= TOMORROW ================= -->
              <h6 *ngIf="tomorrowAnniversaries.length !== 0" class="mb-2">Tomorrow</h6>

              <div
                *ngFor="let user of tomorrowAnniversaries"
                class="bg-light p-2 border border-dashed rounded-top mb-3"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <span class="avatar">
                      <img
                        *ngIf="user.picture; else noAvatar"
                        [src]="apiEndpoint + '/uploads/' + user.picture"
                        class="rounded-circle border border-2"
                      />

                      <ng-template #noAvatar>
                        <span
                          class="avatar avatar-sm rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white"
                          style="width: 32px; height: 32px"
                        >
                          {{ user.firstName.charAt(0) }}
                        </span>
                      </ng-template>
                    </span>

                    <div class="ms-2 overflow-hidden">
                      <h6 class="fs-medium">{{ user.firstName }} {{ user.lastName }}</h6>
                      <p class="fs-13">{{ user.designation?.designationName || '—' }}</p>
                    </div>
                  </div>

                  <button class="btn btn-success btn-xs">
                    <i class="ti ti-confetti me-1"></i>Wish
                  </button>
                </div>
              </div>

              <!-- ================= UPCOMING ================= -->
              <h6 *ngIf="upcomingAnniversaries.length !== 0" class="mb-2">Upcoming</h6>

              <div
                *ngFor="let user of upcomingAnniversaries"
                class="bg-light p-2 border border-dashed rounded-top mb-3"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <span class="avatar">
                      <ng-container *ngIf="user.picture; else noAvatar">
                        <img
                          [src]="apiEndpoint + '/uploads/' + user.picture"
                          class="rounded-circle border border-2"
                          alt="img"
                        />
                      </ng-container>

                      <ng-template #noAvatar>
                        <span
                          class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                          style="width: 40px; height: 40px"
                        >
                          {{ user.firstName.charAt(0) }}
                        </span>
                      </ng-template>
                    </span>

                    <div class="ms-2 overflow-hidden">
                      <h6 class="fs-medium d-flex align-items-center gap-2">
                        {{ user.firstName }} {{ user.lastName }}

                        <!-- 📅 Anniversary Date -->
                        <span class="badge bg-soft-success text-success fs-10">
                          {{ formatAnniversary(user.joiningDate) }}
                        </span>

                        <!-- 🏆 Years Completed -->
                        <span class="badge bg-warning text-dark fs-10">
                          {{ getWorkYears(user.joiningDate) }} yrs
                        </span>
                      </h6>

                      <p class="fs-13">{{ user.designation?.designationName || '—' }}</p>
                    </div>
                  </div>

                  <button class="btn btn-success btn-xs">
                    <i class="ti ti-confetti me-1"></i>Wish
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #noRecords>
            <div class="text-center">Record not available</div>
          </ng-template>
        </div>
      </div>

      <!-- / -->
    </div>

    <div class="row">
      <!-- Total Employee -->
      <div class="col-xxl-4 d-flex">
        <div class="card flex-fill">
          <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
            <h5 class="mb-2">Employee Status</h5>
            <!-- <div class="dropdown mb-2">
              <a href="javascript:void(0);" class="btn btn-white border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown">
                <i class="ti ti-calendar me-1"></i>{{selectedFilterStatusLabel}}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a (click)="changeFilter('month','employee status')" class="dropdown-item rounded-1">This Month</a>
                </li>
                <li>
                  <a (click)="changeFilter('week','employee status')" class="dropdown-item rounded-1">This Week</a>
                </li>
                <li>
                  <a (click)="changeFilter('today','employee status')" class="dropdown-item rounded-1">Today</a>
                </li>
              </ul>
            </div> -->
          </div>
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <p class="fs-13 mb-3">Total Employee</p>
              <h3 class="mb-3">{{ employeeCount }}</h3>
            </div>
            <div class="progress-stacked emp-stack mb-3">
              <!-- Full Time -->
              <div
                class="progress"
                role="progressbar"
                [style.width.%]="employeeStats.fullTime.percentage"
              >
                <div class="progress-bar bg-warning"></div>
              </div>
              <!-- Contract -->
              <div
                class="progress"
                role="progressbar"
                [style.width.%]="employeeStats.contract.percentage"
              >
                <div class="progress-bar bg-secondary"></div>
              </div>
              <!-- Probation -->
              <div
                class="progress"
                role="progressbar"
                [style.width.%]="employeeStats.probation.percentage"
              >
                <div class="progress-bar bg-danger"></div>
              </div>
              <div
                class="progress"
                role="progressbar"
                aria-label="Segment four"
                aria-valuenow="20"
                aria-valuemin="0"
                aria-valuemax="100"
                style="width: 30%"
              >
                <div class="progress-bar bg-pink"></div>
              </div>
            </div>
            <div class="border mb-3">
              <div class="row gx-0">
                <div class="col-6">
                  <div class="p-2 flex-fill border-end border-bottom">
                    <p class="fs-13 mb-2">
                      <i class="ti ti-square-filled text-primary fs-12 me-2"></i>Fulltime
                      <span class="text-gray-9"> ({{ employeeStats.fullTime.percentage }}%) </span>
                    </p>
                    <h2 class="display-1">{{ employeeStats.fullTime.count }}</h2>
                  </div>
                </div>
                <div class="col-6">
                  <div class="p-2 flex-fill border-bottom text-end">
                    <p class="fs-13 mb-2">
                      <i class="ti ti-square-filled me-2 text-secondary fs-12"></i>Contract
                      <span class="text-gray-9"> ({{ employeeStats.contract.percentage }}%) </span>
                    </p>
                    <h2 class="display-1">{{ employeeStats.contract.count }}</h2>
                  </div>
                </div>
                <div class="col-6">
                  <div class="p-2 flex-fill border-end">
                    <p class="fs-13 mb-2">
                      <i class="ti ti-square-filled me-2 text-danger fs-12"></i>Probation
                      <span class="text-gray-9"> ({{ employeeStats.probation.percentage }}%) </span>
                    </p>
                    <h2 class="display-1">{{ employeeStats.probation.count }}</h2>
                  </div>
                </div>
                <!-- <div class="col-6">
                  <div class="p-2 flex-fill text-end">
                    <p class="fs-13 mb-2">
                      <i class="ti ti-square-filled text-pink me-2 fs-12"></i>WFH
                      <span class="text-gray-9">(20%)</span><span class="text-danger">*</span>
                    </p>
                    <h2 class="display-1">04</h2>
                  </div>
                </div> -->
                <div class="col-6">
                  <div class="p-2 flex-fill text-end">
                    <p class="fs-13 mb-2">
                      <i class="ti ti-square-filled text-pink me-2 fs-12"></i>Inactive
                      <span class="text-gray-9">({{ employeeStats.inactive.percentage }}%)</span>
                    </p>
                    <h2 class="display-1">{{ employeeStats.inactive.count }}</h2>
                  </div>
                </div>
              </div>
            </div>
            <h6 class="mb-2">Top Performer <span class="text-danger">*</span></h6>
            <div
              class="p-2 d-flex align-items-center justify-content-between border border-primary bg-primary-100 br-5 mb-4"
            >
              <div class="d-flex align-items-center overflow-hidden">
                <span class="me-2">
                  <i class="ti ti-award-filled text-primary fs-24"></i>
                </span>
                <a href="employee-details.html" class="avatar avatar-md me-2">
                  <img
                    src="assets/img/profiles/avatar-24.jpg"
                    class="rounded-circle border border-white"
                    alt="img"
                  />
                </a>
                <div>
                  <h6 class="text-truncate mb-1 fs-14 fw-medium">
                    <a href="employee-details.html">Daniel Esbella</a>
                  </h6>
                  <p class="fs-13">IOS Developer</p>
                </div>
              </div>
              <div class="text-end">
                <p class="fs-13 mb-1">Performance</p>
                <h5 class="text-primary">99%</h5>
              </div>
            </div>
            <a [routerLink]="eps.hrm.employeePath" class="btn btn-light btn-md w-100"
              >View All Employees</a
            >
          </div>
        </div>
      </div>
      <!-- /Total Employee -->

      <!-- Attendance Overview -->
      <div class="col-xxl-4 col-xl-6 d-flex">
        <div class="card flex-fill">
          <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
            <h5 class="mb-2">Attendance Overview</h5>
            <div class="dropdown mb-2">
              <a
                href="javascript:void(0);"
                class="btn btn-white border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-calendar me-1"></i>{{ selectedFilterOverviewLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    (click)="changeFilter('month', 'attendance overview')"
                    class="dropdown-item rounded-1"
                    >This Month</a
                  >
                </li>
                <li>
                  <a
                    (click)="changeFilter('week', 'attendance overview')"
                    class="dropdown-item rounded-1"
                    >This Week</a
                  >
                </li>
                <li>
                  <a
                    (click)="changeFilter('today', 'attendance overview')"
                    class="dropdown-item rounded-1"
                    >Today</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="card-body">
            <div class="chartjs-wrapper-demo position-relative mb-4">
              <div class="chartjs-wrapper-demo position-relative mb-4">
                <!-- <canvas id="attendance" height="200"></canvas> -->
                <div class="gauge-container">
                  <canvas #attendanceCanvas width="420" height="140"></canvas>
                  <div
                    class="tooltip-attendance"
                    *ngIf="tooltip.show"
                    [style.left.px]="tooltip.x"
                    [style.top.px]="tooltip.y"
                  >
                    {{ tooltip.label }} — {{ tooltip.value }}%
                  </div>
                </div>
                <!-- <div class="position-absolute text-center attendance-canvas">
                  <p class="fs-13 mb-1">Total Attendance</p>
                  <h3>{{ total }}</h3>
                </div> -->
              </div>
            </div>
            <h6 class="mb-3">Status</h6>
            <div class="d-flex justify-content-between">
              <p><i class="ti ti-circle-filled text-success"></i> Present</p>
              <p>{{ presentCount }} ({{ present }}%)</p>
            </div>

            <div class="d-flex justify-content-between">
              <p><i class="ti ti-circle-filled text-secondary"></i> Late</p>
              <p>{{ lateCount }} ({{ late }}%)</p>
            </div>

            <div class="d-flex justify-content-between">
              <p><i class="ti ti-circle-filled text-warning"></i> Leaves</p>
              <p>{{ leaveCount }} ({{ leave }}%)</p>
            </div>

            <div class="d-flex justify-content-between">
              <p><i class="ti ti-circle-filled text-danger"></i> Absent</p>
              <p>{{ absentCount }} ({{ absent }}%)</p>
            </div>

            <div
              class="bg-light br-5 box-shadow-xs p-2 pb-0 d-flex align-items-center justify-content-between flex-wrap"
            >
              <div class="d-flex align-items-center">
                <p class="mb-2 me-2">Total Absenties</p>
                <div class="avatar-list-stacked avatar-group-sm mb-2">
                  <span class="avatar avatar-rounded">
                    <img
                      class="border border-white"
                      src="assets/img/profiles/avatar-27.jpg"
                      alt="img"
                    />
                  </span>
                  <span class="avatar avatar-rounded">
                    <img
                      class="border border-white"
                      src="assets/img/profiles/avatar-30.jpg"
                      alt="img"
                    />
                  </span>
                  <span class="avatar avatar-rounded">
                    <img src="assets/img/profiles/avatar-14.jpg" alt="img" />
                  </span>
                  <span class="avatar avatar-rounded">
                    <img src="assets/img/profiles/avatar-29.jpg" alt="img" />
                  </span>
                  <a
                    class="avatar bg-primary avatar-rounded text-fixed-white fs-10"
                    href="javascript:void(0);"
                  >
                    +1
                  </a>
                </div>
              </div>
              <a
                [routerLink]="eps.attendance.attendanceListPath"
                class="fs-13 link-primary text-decoration-underline mb-2"
                >View Details</a
              >
            </div>
          </div>
        </div>
      </div>
      <!-- /Attendance Overview -->

      <!-- Clock-In/Out -->
      <div class="col-xxl-4 col-xl-6 d-flex align-items-start">
        <div class="card flex-fill">
          <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
            <h5 class="mb-2">Clock-In/Out</h5>
            <!-- <div class="d-flex align-items-center">
              <div class="dropdown mb-2">
                <a href="javascript:void(0);"
                  class="dropdown-toggle btn btn-white btn-sm d-inline-flex align-items-center border-0 fs-13 me-2"
                  data-bs-toggle="dropdown">
                  All Departments
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">Finance</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">Development</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">Marketing</a>
                  </li>
                </ul>
              </div>
              <div class="dropdown mb-2">
                <a href="javascript:void(0);" class="btn btn-white border btn-sm d-inline-flex align-items-center"
                  data-bs-toggle="dropdown">
                  <i class="ti ti-calendar me-1"></i>{{selectedFilterClockInOutLabel}}
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a (click)="changeFilter('month','clock in out')" class="dropdown-item rounded-1">This Month</a>
                  </li>
                  <li>
                    <a (click)="changeFilter('week','clock in out')" class="dropdown-item rounded-1">This Week</a>
                  </li>
                  <li>
                    <a (click)="changeFilter('today','clock in out')" class="dropdown-item rounded-1">Today</a>
                  </li>
                </ul>
              </div>
            </div> -->
          </div>
          <ng-container *ngIf="onTimeUsers.length !== 0 || lateUsers.length !== 0; else noRecords">
            <div class="card-body">
              <!-- On-Time Users -->
              <div *ngFor="let user of onTimeUsers" class="mb-3 p-2 border br-5">
                <div
                  class="d-flex align-items-center justify-content-between"
                  (click)="toggleUserDetails(user)"
                >
                  <div class="d-flex align-items-center">
                    <a href="javascript:void(0);" class="avatar flex-shrink-0">
                      <!-- If avatar exists, show image -->
                      <ng-container *ngIf="user.avatar; else noAvatar">
                        <img
                          [src]="apiEndpoint + '/uploads/' + user.avatar"
                          class="rounded-circle border border-2"
                          alt="img"
                        />
                      </ng-container>

                      <!-- Fallback: first letter of user name -->
                      <ng-template #noAvatar>
                        <span
                          class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                          style="width: 40px; height: 40px"
                        >
                          {{ user.name.charAt(0) }}
                        </span>
                      </ng-template>
                    </a>
                    <div class="ms-2">
                      <h6 class="fs-14 fw-medium text-truncate">{{ user.name }}</h6>
                      <p class="fs-13">{{ user.department }}</p>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <a href="javascript:void(0);" class="link-default me-2"
                      ><i class="ti ti-clock-share"></i
                    ></a>
                    <span
                      class="fs-10 fw-medium d-inline-flex align-items-center badge badge-success"
                    >
                      <i class="ti ti-circle-filled fs-5 me-1"></i
                      >{{ user.firstClockIn | date: 'shortTime' }}
                    </span>
                  </div>
                </div>

                <!-- Expanded Details -->
                <div
                  *ngIf="expandedUser === user.id"
                  class="d-flex align-items-center justify-content-between flex-wrap mt-2 border br-5 p-2 pb-0"
                >
                  <div>
                    <p class="mb-1 d-inline-flex align-items-center">
                      <i class="ti ti-circle-filled text-success fs-5 me-1"></i>Clock In
                    </p>
                    <h6 class="fs-13 fw-normal mb-2">
                      {{ user.firstClockIn | date: 'shortTime' }}
                    </h6>
                  </div>
                  <div>
                    <p class="mb-1 d-inline-flex align-items-center">
                      <i class="ti ti-circle-filled text-danger fs-5 me-1"></i>Clock Out
                    </p>
                    <h6 class="fs-13 fw-normal mb-2">
                      {{ user.lastClockOut ? (user.lastClockOut | date: 'shortTime') : 'Continue' }}
                    </h6>
                  </div>
                  <div *ngIf="user.totalWorkHours">
                    <p class="mb-1 d-inline-flex align-items-center">
                      <i class="ti ti-circle-filled text-warning fs-5 me-1"></i>Production
                    </p>
                    <h6 class="fs-13 fw-normal mb-2">{{ user.totalWorkHours }}</h6>
                  </div>
                </div>
              </div>

              <!-- Late Users -->
              <h6 class="mb-2 mt-3" *ngIf="lateUsers.length !== 0">Late</h6>
              <div *ngFor="let user of lateUsers" class="mb-3 p-2 border border-dashed br-5">
                <!-- Main Row -->
                <div
                  class="d-flex align-items-center justify-content-between"
                  (click)="toggleUserDetails(user)"
                >
                  <div class="d-flex align-items-center">
                    <a href="javascript:void(0);" class="avatar flex-shrink-0">
                      <img
                        *ngIf="user.avatar; else noAvatarLate"
                        [src]="apiEndpoint + '/uploads/' + user.avatar"
                        class="rounded-circle border border-2"
                        alt="img"
                      />

                      <ng-template #noAvatarLate>
                        <span
                          class="avatar avatar-sm rounded-circle d-inline-flex align-items-center justify-content-center bg-danger text-white"
                          style="width: 32px; height: 32px"
                        >
                          {{ user.name.charAt(0) }}
                        </span>
                      </ng-template>
                    </a>

                    <div class="ms-2">
                      <h6 class="fs-14 fw-medium text-truncate">
                        {{ user.name }}
                        <span class="badge badge-danger ms-1">
                          <i class="ti ti-clock-hour-11 me-1"></i>{{ user.lateDuration }}
                        </span>
                      </h6>
                      <p class="fs-13">{{ user.department }}</p>
                    </div>
                  </div>

                  <div class="d-flex align-items-center">
                    <a href="javascript:void(0);" class="link-default me-2">
                      <i class="ti ti-clock-share"></i>
                    </a>
                    <span class="fs-10 fw-medium badge badge-danger">
                      <i class="ti ti-circle-filled fs-5 me-1"></i>
                      {{ user.firstClockIn | date: 'shortTime' }}
                    </span>
                  </div>
                </div>

                <!-- Expanded Details (SAME AS ON-TIME) -->
                <div
                  *ngIf="expandedUser === user.id"
                  class="d-flex align-items-center justify-content-between flex-wrap mt-2 border br-5 p-2 pb-0"
                >
                  <div>
                    <p class="mb-1">
                      <i class="ti ti-circle-filled text-success me-1"></i>Clock In
                    </p>
                    <h6 class="fs-13 fw-normal mb-2">
                      {{ user.firstClockIn | date: 'shortTime' }}
                    </h6>
                  </div>

                  <div>
                    <p class="mb-1">
                      <i class="ti ti-circle-filled text-danger me-1"></i>Clock Out
                    </p>
                    <h6 class="fs-13 fw-normal mb-2">
                      {{ user.lastClockOut ? (user.lastClockOut | date: 'shortTime') : 'Continue' }}
                    </h6>
                  </div>

                  <div *ngIf="user.totalWorkHours">
                    <p class="mb-1">
                      <i class="ti ti-circle-filled text-warning me-1"></i>Production
                    </p>
                    <h6 class="fs-13 fw-normal mb-2">{{ user.totalWorkHours }}</h6>
                  </div>
                </div>
              </div>

              <!-- View All Button -->
              <a
                [routerLink]="eps.attendance.attendanceListPath"
                class="btn btn-light btn-md w-100"
              >
                View All Attendance
              </a>
            </div>
          </ng-container>
          <ng-template #noRecords>
            <div class="text-center">Record not available</div>
          </ng-template>
        </div>
        <!-- /Clock-In/Out -->
      </div>

      <!-- <div class="row"> -->
      <!-- Jobs Applicants -->
      <div class="col-xxl-4 d-flex">
        <div class="card flex-fill">
          <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
            <h5 class="mb-2">Jobs Applicants</h5>
            <a href="job-list.html" class="btn btn-light btn-md mb-2">View All</a>
          </div>
          <div class="card-body">
            <ul
              class="nav nav-tabs tab-style-1 nav-justified d-sm-flex d-block p-0 mb-4"
              role="tablist"
            >
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link fw-medium"
                  data-bs-toggle="tab"
                  data-bs-target="#openings"
                  aria-current="page"
                  href="#openings"
                  aria-selected="true"
                  role="tab"
                  >Openings</a
                >
              </li>
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link fw-medium active"
                  data-bs-toggle="tab"
                  data-bs-target="#applicants"
                  href="#applicants"
                  aria-selected="false"
                  tabindex="-1"
                  role="tab"
                  >Applicants</a
                >
              </li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane fade" id="openings">
                <div class="d-flex align-items-center justify-content-between mb-4">
                  <div class="d-flex align-items-center">
                    <a href="#" class="avatar overflow-hidden flex-shrink-0 bg-gray-100">
                      <img
                        src="assets/img/icons/apple.svg"
                        class="img-fluid rounded-circle w-auto h-auto"
                        alt="img"
                      />
                    </a>
                    <div class="ms-2 overflow-hidden">
                      <p class="text-dark fw-medium text-truncate mb-0">
                        <a href="javascript:void(0);">Senior IOS Developer</a>
                      </p>
                      <span class="fs-12">No of Openings : 25 </span>
                    </div>
                  </div>
                  <a
                    href="javascript:void(0);"
                    class="btn btn-light btn-sm p-0 btn-icon d-flex align-items-center justify-content-center"
                    ><i class="ti ti-edit"></i
                  ></a>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-4">
                  <div class="d-flex align-items-center">
                    <a href="#" class="avatar overflow-hidden flex-shrink-0 bg-gray-100">
                      <img
                        src="assets/img/icons/php.svg"
                        class="img-fluid w-auto h-auto"
                        alt="img"
                      />
                    </a>
                    <div class="ms-2 overflow-hidden">
                      <p class="text-dark fw-medium text-truncate mb-0">
                        <a href="javascript:void(0);">Junior PHP Developer</a>
                      </p>
                      <span class="fs-12">No of Openings : 20 </span>
                    </div>
                  </div>
                  <a
                    href="javascript:void(0);"
                    class="btn btn-light btn-sm p-0 btn-icon d-flex align-items-center justify-content-center"
                    ><i class="ti ti-edit"></i
                  ></a>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-4">
                  <div class="d-flex align-items-center">
                    <a href="#" class="avatar overflow-hidden flex-shrink-0 bg-gray-100">
                      <img
                        src="assets/img/icons/react.svg"
                        class="img-fluid w-auto h-auto"
                        alt="img"
                      />
                    </a>
                    <div class="ms-2 overflow-hidden">
                      <p class="text-dark fw-medium text-truncate mb-0">
                        <a href="javascript:void(0);">Junior React Developer </a>
                      </p>
                      <span class="fs-12">No of Openings : 30 </span>
                    </div>
                  </div>
                  <a
                    href="javascript:void(0);"
                    class="btn btn-light btn-sm p-0 btn-icon d-flex align-items-center justify-content-center"
                    ><i class="ti ti-edit"></i
                  ></a>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-0">
                  <div class="d-flex align-items-center">
                    <a href="#" class="avatar overflow-hidden flex-shrink-0 bg-gray-100">
                      <img
                        src="assets/img/icons/laravel-icon.svg"
                        class="img-fluid w-auto h-auto"
                        alt="img"
                      />
                    </a>
                    <div class="ms-2 overflow-hidden">
                      <p class="text-dark fw-medium text-truncate mb-0">
                        <a href="javascript:void(0);">Senior Laravel Developer</a>
                      </p>
                      <span class="fs-12">No of Openings : 40 </span>
                    </div>
                  </div>
                  <a
                    href="javascript:void(0);"
                    class="btn btn-light btn-sm p-0 btn-icon d-flex align-items-center justify-content-center"
                    ><i class="ti ti-edit"></i
                  ></a>
                </div>
              </div>
              <div class="tab-pane fade show active" id="applicants">
                <div class="d-flex align-items-center justify-content-between mb-4">
                  <div class="d-flex align-items-center">
                    <a href="#" class="avatar overflow-hidden flex-shrink-0">
                      <img
                        src="assets/img/users/user-09.jpg"
                        class="img-fluid rounded-circle"
                        alt="img"
                      />
                    </a>
                    <div class="ms-2 overflow-hidden">
                      <p class="text-dark fw-medium text-truncate mb-0">
                        <a href="#">Brian Villalobos</a>
                      </p>
                      <span class="fs-13 d-inline-flex align-items-center"
                        >Exp : 5+ Years<i class="ti ti-circle-filled fs-4 mx-2 text-primary"></i
                        >USA</span
                      >
                    </div>
                  </div>
                  <span class="badge badge-secondary badge-xs">UI/UX Designer</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-4">
                  <div class="d-flex align-items-center">
                    <a href="#" class="avatar overflow-hidden flex-shrink-0">
                      <img
                        src="assets/img/users/user-32.jpg"
                        class="img-fluid rounded-circle"
                        alt="img"
                      />
                    </a>
                    <div class="ms-2 overflow-hidden">
                      <p class="text-dark fw-medium text-truncate mb-0">
                        <a href="#">Anthony Lewis</a>
                      </p>
                      <span class="fs-13 d-inline-flex align-items-center"
                        >Exp : 4+ Years<i class="ti ti-circle-filled fs-4 mx-2 text-primary"></i
                        >USA</span
                      >
                    </div>
                  </div>
                  <span class="badge badge-info badge-xs">Python Developer</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-4">
                  <div class="d-flex align-items-center">
                    <a href="#" class="avatar overflow-hidden flex-shrink-0">
                      <img
                        src="assets/img/users/user-32.jpg"
                        class="img-fluid rounded-circle"
                        alt="img"
                      />
                    </a>
                    <div class="ms-2 overflow-hidden">
                      <p class="text-dark fw-medium text-truncate mb-0">
                        <a href="#">Stephan Peralt</a>
                      </p>
                      <span class="fs-13 d-inline-flex align-items-center"
                        >Exp : 6+ Years<i class="ti ti-circle-filled fs-4 mx-2 text-primary"></i
                        >USA</span
                      >
                    </div>
                  </div>
                  <span class="badge badge-pink badge-xs">Android Developer</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-0">
                  <div class="d-flex align-items-center">
                    <a href="javascript:void(0);" class="avatar overflow-hidden flex-shrink-0">
                      <img
                        src="assets/img/users/user-34.jpg"
                        class="img-fluid rounded-circle"
                        alt="img"
                      />
                    </a>
                    <div class="ms-2 overflow-hidden">
                      <p class="text-dark fw-medium text-truncate mb-0">
                        <a href="javascript:void(0);">Doglas Martini</a>
                      </p>
                      <span class="fs-13 d-inline-flex align-items-center"
                        >Exp : 2+ Years<i class="ti ti-circle-filled fs-4 mx-2 text-primary"></i
                        >USA</span
                      >
                    </div>
                  </div>
                  <span class="badge badge-purple badge-xs">React Developer</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Jobs Applicants -->

      <!-- Employees -->
      <div class="col-xxl-4 col-xl-6 d-flex">
        <div class="card flex-fill">
          <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
            <h5 class="mb-2">Employees</h5>
            <a [routerLink]="eps.hrm.employeePath" class="btn btn-light btn-md mb-2">View All</a>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-nowrap mb-0">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Department</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let user of employees">
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="avatar me-2">
                          <ng-container *ngIf="user.picture; else noAvatar">
                            <img
                              [src]="apiEndpoint + '/uploads/' + user.picture"
                              class="rounded-circle border border-2"
                              alt="img"
                            />
                          </ng-container>

                          <ng-template #noAvatar>
                            <span
                              class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                              style="width: 40px; height: 40px"
                            >
                              {{ user.firstName.charAt(0) }}
                            </span>
                          </ng-template>
                        </span>

                        <div>
                          <h6 class="fw-medium mb-0">{{ user.firstName }} {{ user.lastName }}</h6>
                          <span class="fs-12 text-muted">
                            {{ user.designationName || 'No Designation' }}
                          </span>
                        </div>
                      </div>
                    </td>

                    <td>
                      <span class="badge badge-secondary-transparent badge-xs">
                        {{ user.departmentName || 'N/A' }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- /Employees -->

      <!-- Todo -->
      <div class="col-xxl-4 col-xl-6 d-flex">
        <div class="card flex-fill">
          <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
            <h5 class="mb-2">Todo</h5>
            <div class="d-flex align-items-center">
              <div class="dropdown mb-2 me-2">
                <a
                  href="javascript:void(0);"
                  class="btn btn-white border btn-sm d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  <i class="ti ti-calendar me-1"></i>Today
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">This Month</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">This Week</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">Today</a>
                  </li>
                </ul>
              </div>
              <a
                href="#"
                class="btn btn-primary btn-icon btn-xs rounded-circle d-flex align-items-center justify-content-center p-0 mb-2"
                data-bs-toggle="modal"
                data-bs-target="#add_todo"
                ><i class="ti ti-plus fs-16"></i
              ></a>
            </div>
          </div>
          <div class="card-body">
            <div class="d-flex align-items-center todo-item border p-2 br-5 mb-2">
              <i class="ti ti-grid-dots me-2"></i>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="todo1" />
                <label class="form-check-label fw-medium" for="todo1">Add Holidays</label>
              </div>
            </div>
            <div class="d-flex align-items-center todo-item border p-2 br-5 mb-2">
              <i class="ti ti-grid-dots me-2"></i>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="todo2" />
                <label class="form-check-label fw-medium" for="todo2">Add Meeting to Client</label>
              </div>
            </div>
            <div class="d-flex align-items-center todo-item border p-2 br-5 mb-2">
              <i class="ti ti-grid-dots me-2"></i>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="todo3" />
                <label class="form-check-label fw-medium" for="todo3">Chat with Adrian</label>
              </div>
            </div>
            <div class="d-flex align-items-center todo-item border p-2 br-5 mb-2">
              <i class="ti ti-grid-dots me-2"></i>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="todo4" />
                <label class="form-check-label fw-medium" for="todo4">Management Call</label>
              </div>
            </div>
            <div class="d-flex align-items-center todo-item border p-2 br-5 mb-2">
              <i class="ti ti-grid-dots me-2"></i>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="todo5" />
                <label class="form-check-label fw-medium" for="todo5">Add Payroll</label>
              </div>
            </div>
            <div class="d-flex align-items-center todo-item border p-2 br-5 mb-0">
              <i class="ti ti-grid-dots me-2"></i>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="todo6" />
                <label class="form-check-label fw-medium" for="todo6"
                  >Add Policy for Increment
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Todo -->
      <!-- </div> -->

      <!-- <div class="row"> -->
      <!-- Sales Overview -->
      <div class="col-xl-7 d-flex">
        <div class="card flex-fill">
          <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
            <h5 class="mb-2">Sales Overview</h5>
            <div class="d-flex align-items-center">
              <div class="dropdown mb-2">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle btn btn-white border-0 btn-sm d-inline-flex align-items-center fs-13 me-2"
                  data-bs-toggle="dropdown"
                >
                  All Departments
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">UI/UX Designer</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">HR Manager</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">Junior Tester</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body pb-0">
            <div class="d-flex align-items-center justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-1">
                <p class="fs-13 text-gray-9 me-3 mb-0">
                  <i class="ti ti-square-filled me-2 text-primary"></i>Income
                </p>
                <p class="fs-13 text-gray-9 mb-0">
                  <i class="ti ti-square-filled me-2 text-gray-2"></i>Expenses
                </p>
              </div>
              <p class="fs-13 mb-1">Last Updated at 11:30PM</p>
            </div>
            <div id="sales-income"></div>
          </div>
        </div>
      </div>
      <!-- /Sales Overview -->

      <!-- Invoices -->
      <div class="col-xl-5 d-flex">
        <div class="card flex-fill">
          <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
            <h5 class="mb-2">Invoices</h5>
            <div class="d-flex align-items-center">
              <div class="dropdown mb-2">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle btn btn-white btn-sm d-inline-flex align-items-center fs-13 me-2 border-0"
                  data-bs-toggle="dropdown"
                >
                  Invoices
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">Invoices</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">Paid</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">Unpaid</a>
                  </li>
                </ul>
              </div>
              <div class="dropdown mb-2">
                <a
                  href="javascript:void(0);"
                  class="btn btn-white border btn-sm d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  <i class="ti ti-calendar me-1"></i>This Week
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">This Month</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">This Week</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">Today</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body pt-2">
            <div class="table-responsive pt-1">
              <table class="table table-nowrap table-borderless mb-0">
                <tbody>
                  <tr>
                    <td class="px-0">
                      <div class="d-flex align-items-center">
                        <a href="invoice-details.html" class="avatar">
                          <img
                            src="assets/img/users/user-39.jpg"
                            class="img-fluid rounded-circle"
                            alt="img"
                          />
                        </a>
                        <div class="ms-2">
                          <h6 class="fw-medium">
                            <a href="invoice-details.html">Redesign Website</a>
                          </h6>
                          <span class="fs-13 d-inline-flex align-items-center"
                            >#INVOO2<i class="ti ti-circle-filled fs-4 mx-1 text-primary"></i
                            >Logistics</span
                          >
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="fs-13 mb-1">Payment</p>
                      <h6 class="fw-medium">$3560</h6>
                    </td>
                    <td class="px-0 text-end">
                      <span
                        class="badge badge-danger-transparent badge-xs d-inline-flex align-items-center"
                        ><i class="ti ti-circle-filled fs-5 me-1"></i>Unpaid</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-0">
                      <div class="d-flex align-items-center">
                        <a href="invoice-details.html" class="avatar">
                          <img
                            src="assets/img/users/user-40.jpg"
                            class="img-fluid rounded-circle"
                            alt="img"
                          />
                        </a>
                        <div class="ms-2">
                          <h6 class="fw-medium">
                            <a href="invoice-details.html">Module Completion</a>
                          </h6>
                          <span class="fs-13 d-inline-flex align-items-center"
                            >#INVOO5<i class="ti ti-circle-filled fs-4 mx-1 text-primary"></i>Yip
                            Corp</span
                          >
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="fs-13 mb-1">Payment</p>
                      <h6 class="fw-medium">$4175</h6>
                    </td>
                    <td class="px-0 text-end">
                      <span
                        class="badge badge-danger-transparent badge-xs d-inline-flex align-items-center"
                        ><i class="ti ti-circle-filled fs-5 me-1"></i>Unpaid</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-0">
                      <div class="d-flex align-items-center">
                        <a href="invoice-details.html" class="avatar">
                          <img
                            src="assets/img/users/user-55.jpg"
                            class="img-fluid rounded-circle"
                            alt="img"
                          />
                        </a>
                        <div class="ms-2">
                          <h6 class="fw-medium">
                            <a href="invoice-details.html">Change on Emp Module</a>
                          </h6>
                          <span class="fs-13 d-inline-flex align-items-center"
                            >#INVOO3<i class="ti ti-circle-filled fs-4 mx-1 text-primary"></i>Ignis
                            LLP</span
                          >
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="fs-13 mb-1">Payment</p>
                      <h6 class="fw-medium">$6985</h6>
                    </td>
                    <td class="px-0 text-end">
                      <span
                        class="badge badge-danger-transparent badge-xs d-inline-flex align-items-center"
                        ><i class="ti ti-circle-filled fs-5 me-1"></i>Unpaid</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-0">
                      <div class="d-flex align-items-center">
                        <a href="invoice-details.html" class="avatar">
                          <img
                            src="assets/img/users/user-42.jpg"
                            class="img-fluid rounded-circle"
                            alt="img"
                          />
                        </a>
                        <div class="ms-2">
                          <h6 class="fw-medium">
                            <a href="invoice-details.html">Changes on the Board</a>
                          </h6>
                          <span class="fs-13 d-inline-flex align-items-center"
                            >#INVOO2<i class="ti ti-circle-filled fs-4 mx-1 text-primary"></i>Ignis
                            LLP</span
                          >
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="fs-13 mb-1">Payment</p>
                      <h6 class="fw-medium">$1457</h6>
                    </td>
                    <td class="px-0 text-end">
                      <span
                        class="badge badge-danger-transparent badge-xs d-inline-flex align-items-center"
                        ><i class="ti ti-circle-filled fs-5 me-1"></i>Unpaid</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-0">
                      <div class="d-flex align-items-center">
                        <a href="invoice-details.html" class="avatar">
                          <img
                            src="assets/img/users/user-44.jpg"
                            class="img-fluid rounded-circle"
                            alt="img"
                          />
                        </a>
                        <div class="ms-2">
                          <h6 class="fw-medium">
                            <a href="invoice-details.html">Hospital Management</a>
                          </h6>
                          <span class="fs-13 d-inline-flex align-items-center"
                            >#INVOO6<i class="ti ti-circle-filled fs-4 mx-1 text-primary"></i>HCL
                            Corp</span
                          >
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="fs-13 mb-1">Payment</p>
                      <h6 class="fw-medium">$6458</h6>
                    </td>
                    <td class="px-0 text-end">
                      <span
                        class="badge badge-success-transparent badge-xs d-inline-flex align-items-center"
                        ><i class="ti ti-circle-filled fs-5 me-1"></i>Paid</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <a href="invoice.html" class="btn btn-light btn-md w-100 mt-2">View All</a>
          </div>
        </div>
      </div>
      <!-- /Invoices -->
      <!-- </div> -->

      <!-- <div class="row"> -->
      <!-- Projects -->
      <div class="col-xxl-8 col-xl-7 d-flex">
        <div class="card flex-fill">
          <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
            <h5 class="mb-2">Projects</h5>
            <div class="d-flex align-items-center">
              <div class="dropdown mb-2">
                <a
                  href="javascript:void(0);"
                  class="btn btn-white border btn-sm d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  <i class="ti ti-calendar me-1"></i>This Week
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">This Month</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">This Week</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">Today</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-nowrap mb-0">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Team</th>
                    <th>Hours</th>
                    <th>Deadline</th>
                    <th>Priority</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><a href="project-details.html" class="link-default">PRO-001</a></td>
                    <td>
                      <h6 class="fw-medium">
                        <a href="project-details.html">Office Management App</a>
                      </h6>
                    </td>
                    <td>
                      <div class="avatar-list-stacked avatar-group-sm">
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-02.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-03.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-05.jpg"
                            alt="img"
                          />
                        </span>
                      </div>
                    </td>
                    <td>
                      <p class="mb-1">15/255 Hrs</p>
                      <div
                        class="progress progress-xs w-100"
                        role="progressbar"
                        aria-valuenow="40"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        <div class="progress-bar bg-primary" style="width: 40%"></div>
                      </div>
                    </td>
                    <td>12 Sep 2024</td>
                    <td>
                      <span class="badge badge-danger d-inline-flex align-items-center badge-xs">
                        <!-- -->
                        High
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><a href="project-details.html" class="link-default">PRO-002</a></td>
                    <td>
                      <h6 class="fw-medium">
                        <a href="project-details.html">Clinic Management </a>
                      </h6>
                    </td>
                    <td>
                      <div class="avatar-list-stacked avatar-group-sm">
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-06.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-07.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-08.jpg"
                            alt="img"
                          />
                        </span>
                        <a
                          class="avatar bg-primary avatar-rounded text-fixed-white fs-10 fw-medium"
                          href="javascript:void(0);"
                        >
                          +1
                        </a>
                      </div>
                    </td>
                    <td>
                      <p class="mb-1">15/255 Hrs</p>
                      <div
                        class="progress progress-xs w-100"
                        role="progressbar"
                        aria-valuenow="40"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        <div class="progress-bar bg-primary" style="width: 40%"></div>
                      </div>
                    </td>
                    <td>24 Oct 2024</td>
                    <td>
                      <span class="badge badge-success d-inline-flex align-items-center badge-xs">
                        <!-- -->
                        Low
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><a href="project-details.html" class="link-default">PRO-003</a></td>
                    <td>
                      <h6 class="fw-medium">
                        <a href="project-details.html">Educational Platform</a>
                      </h6>
                    </td>
                    <td>
                      <div class="avatar-list-stacked avatar-group-sm">
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-06.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-08.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-09.jpg"
                            alt="img"
                          />
                        </span>
                      </div>
                    </td>
                    <td>
                      <p class="mb-1">40/255 Hrs</p>
                      <div
                        class="progress progress-xs w-100"
                        role="progressbar"
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        <div class="progress-bar bg-primary" style="width: 50%"></div>
                      </div>
                    </td>
                    <td>18 Feb 2024</td>
                    <td>
                      <span class="badge badge-pink d-inline-flex align-items-center badge-xs">
                        <!-- -->
                        Medium
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><a href="project-details.html" class="link-default">PRO-004</a></td>
                    <td>
                      <h6 class="fw-medium">
                        <a href="project-details.html">Chat & Call Mobile App</a>
                      </h6>
                    </td>
                    <td>
                      <div class="avatar-list-stacked avatar-group-sm">
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-11.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-12.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-13.jpg"
                            alt="img"
                          />
                        </span>
                      </div>
                    </td>
                    <td>
                      <p class="mb-1">35/155 Hrs</p>
                      <div
                        class="progress progress-xs w-100"
                        role="progressbar"
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        <div class="progress-bar bg-primary" style="width: 50%"></div>
                      </div>
                    </td>
                    <td>19 Feb 2024</td>
                    <td>
                      <span class="badge badge-danger d-inline-flex align-items-center badge-xs">
                        <!-- -->
                        High
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><a href="project-details.html" class="link-default">PRO-005</a></td>
                    <td>
                      <h6 class="fw-medium">
                        <a href="project-details.html">Travel Planning Website</a>
                      </h6>
                    </td>
                    <td>
                      <div class="avatar-list-stacked avatar-group-sm">
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-17.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-18.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-19.jpg"
                            alt="img"
                          />
                        </span>
                      </div>
                    </td>
                    <td>
                      <p class="mb-1">50/235 Hrs</p>
                      <div
                        class="progress progress-xs w-100"
                        role="progressbar"
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        <div class="progress-bar bg-primary" style="width: 50%"></div>
                      </div>
                    </td>
                    <td>18 Feb 2024</td>
                    <td>
                      <span class="badge badge-pink d-inline-flex align-items-center badge-xs">
                        <!-- -->
                        Medium
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><a href="project-details.html" class="link-default">PRO-006</a></td>
                    <td>
                      <h6 class="fw-medium">
                        <a href="project-details.html">Service Booking Software</a>
                      </h6>
                    </td>
                    <td>
                      <div class="avatar-list-stacked avatar-group-sm">
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-06.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-08.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-09.jpg"
                            alt="img"
                          />
                        </span>
                      </div>
                    </td>
                    <td>
                      <p class="mb-1">40/255 Hrs</p>
                      <div
                        class="progress progress-xs w-100"
                        role="progressbar"
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        <div class="progress-bar bg-primary" style="width: 50%"></div>
                      </div>
                    </td>
                    <td>20 Feb 2024</td>
                    <td>
                      <span class="badge badge-success d-inline-flex align-items-center badge-xs">
                        <!-- -->
                        Low
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="border-0">
                      <a href="project-details.html" class="link-default">PRO-008</a>
                    </td>
                    <td class="border-0">
                      <h6 class="fw-medium">
                        <a href="project-details.html">Travel Planning Website</a>
                      </h6>
                    </td>
                    <td class="border-0">
                      <div class="avatar-list-stacked avatar-group-sm">
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-15.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-16.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="assets/img/profiles/avatar-17.jpg"
                            alt="img"
                          />
                        </span>
                        <a
                          class="avatar bg-primary avatar-rounded text-fixed-white fs-10 fw-medium"
                          href="javascript:void(0);"
                        >
                          +2
                        </a>
                      </div>
                    </td>
                    <td class="border-0">
                      <p class="mb-1">15/255 Hrs</p>
                      <div
                        class="progress progress-xs w-100"
                        role="progressbar"
                        aria-valuenow="45"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        <div class="progress-bar bg-primary" style="width: 45%"></div>
                      </div>
                    </td>
                    <td class="border-0">17 Oct 2024</td>
                    <td class="border-0">
                      <span class="badge badge-pink d-inline-flex align-items-center badge-xs">
                        <!-- -->
                        Medium
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- /Projects -->

      <!-- Tasks Statistics -->
      <div class="col-xxl-4 col-xl-5 d-flex">
        <div class="card flex-fill">
          <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
            <h5 class="mb-2">Tasks Statistics</h5>
            <div class="d-flex align-items-center">
              <div class="dropdown mb-2">
                <a
                  href="javascript:void(0);"
                  class="btn btn-white border btn-sm d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  <i class="ti ti-calendar me-1"></i>This Week
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">This Month</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">This Week</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">Today</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="chartjs-wrapper-demo position-relative mb-4">
              <canvas id="mySemiDonutChart" height="190"></canvas>
              <div class="position-absolute text-center attendance-canvas">
                <p class="fs-13 mb-1">Total Tasks</p>
                <h3>124/165</h3>
              </div>
            </div>
            <div class="d-flex align-items-center flex-wrap">
              <div class="border-end text-center me-2 pe-2 mb-3">
                <p class="fs-13 d-inline-flex align-items-center mb-1">
                  <i class="ti ti-circle-filled fs-10 me-1 text-warning"></i>Ongoing
                </p>
                <h5>24%</h5>
              </div>
              <div class="border-end text-center me-2 pe-2 mb-3">
                <p class="fs-13 d-inline-flex align-items-center mb-1">
                  <i class="ti ti-circle-filled fs-10 me-1 text-info"></i>On Hold
                </p>
                <h5>10%</h5>
              </div>
              <div class="border-end text-center me-2 pe-2 mb-3">
                <p class="fs-13 d-inline-flex align-items-center mb-1">
                  <i class="ti ti-circle-filled fs-10 me-1 text-danger"></i>Overdue
                </p>
                <h5>16%</h5>
              </div>
              <div class="text-center me-2 pe-2 mb-3">
                <p class="fs-13 d-inline-flex align-items-center mb-1">
                  <i class="ti ti-circle-filled fs-10 me-1 text-success"></i>Ongoing
                </p>
                <h5>40%</h5>
              </div>
            </div>
            <div class="bg-dark br-5 p-3 pb-0 d-flex align-items-center justify-content-between">
              <div class="mb-2">
                <h4 class="text-success">389/689 hrs</h4>
                <p class="fs-13 mb-0">Spent on Overall Tasks This Week</p>
              </div>
              <a href="tasks.html" class="btn btn-sm btn-light mb-2 text-nowrap">View All</a>
            </div>
          </div>
        </div>
      </div>
      <!-- /Tasks Statistics -->
      <!-- </div> -->

      <!-- <div class="row"> -->
      <!-- Schedules -->
      <div class="col-xxl-4 d-flex">
        <div class="card flex-fill">
          <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
            <h5 class="mb-2">Schedules</h5>
            <a href="candidates.html" class="btn btn-light btn-md mb-2">View All</a>
          </div>
          <div class="card-body">
            <div class="bg-light p-3 br-5 mb-4">
              <span class="badge badge-secondary badge-xs mb-1">UI/ UX Designer</span>
              <h6 class="mb-2 text-truncate">Interview Candidates - UI/UX Designer</h6>
              <div class="d-flex align-items-center flex-wrap">
                <p class="fs-13 mb-1 me-2">
                  <i class="ti ti-calendar-event me-2"></i>Thu, 15 Feb 2025
                </p>
                <p class="fs-13 mb-1">
                  <i class="ti ti-clock-hour-11 me-2"></i>01:00 PM - 02:20 PM
                </p>
              </div>
              <div class="d-flex align-items-center justify-content-between border-top mt-2 pt-3">
                <div class="avatar-list-stacked avatar-group-sm">
                  <span class="avatar avatar-rounded">
                    <img class="border border-white" src="assets/img/users/user-49.jpg" alt="img" />
                  </span>
                  <span class="avatar avatar-rounded">
                    <img class="border border-white" src="assets/img/users/user-13.jpg" alt="img" />
                  </span>
                  <span class="avatar avatar-rounded">
                    <img class="border border-white" src="assets/img/users/user-11.jpg" alt="img" />
                  </span>
                  <span class="avatar avatar-rounded">
                    <img class="border border-white" src="assets/img/users/user-22.jpg" alt="img" />
                  </span>
                  <span class="avatar avatar-rounded">
                    <img class="border border-white" src="assets/img/users/user-58.jpg" alt="img" />
                  </span>
                  <a
                    class="avatar bg-primary avatar-rounded text-fixed-white fs-10 fw-medium"
                    href="javascript:void(0);"
                  >
                    +3
                  </a>
                </div>
                <a href="#" class="btn btn-primary btn-xs">Join Meeting</a>
              </div>
            </div>
            <div class="bg-light p-3 br-5 mb-0">
              <span class="badge badge-dark badge-xs mb-1">IOS Developer</span>
              <h6 class="mb-2 text-truncate">Interview Candidates - IOS Developer</h6>
              <div class="d-flex align-items-center flex-wrap">
                <p class="fs-13 mb-1 me-2">
                  <i class="ti ti-calendar-event me-2"></i>Thu, 15 Feb 2025
                </p>
                <p class="fs-13 mb-1">
                  <i class="ti ti-clock-hour-11 me-2"></i>02:00 PM - 04:20 PM
                </p>
              </div>
              <div class="d-flex align-items-center justify-content-between border-top mt-2 pt-3">
                <div class="avatar-list-stacked avatar-group-sm">
                  <span class="avatar avatar-rounded">
                    <img class="border border-white" src="assets/img/users/user-49.jpg" alt="img" />
                  </span>
                  <span class="avatar avatar-rounded">
                    <img class="border border-white" src="assets/img/users/user-13.jpg" alt="img" />
                  </span>
                  <span class="avatar avatar-rounded">
                    <img class="border border-white" src="assets/img/users/user-11.jpg" alt="img" />
                  </span>
                  <span class="avatar avatar-rounded">
                    <img class="border border-white" src="assets/img/users/user-22.jpg" alt="img" />
                  </span>
                  <span class="avatar avatar-rounded">
                    <img class="border border-white" src="assets/img/users/user-58.jpg" alt="img" />
                  </span>
                  <a
                    class="avatar bg-primary avatar-rounded text-fixed-white fs-10 fw-medium"
                    href="javascript:void(0);"
                  >
                    +3
                  </a>
                </div>
                <a href="#" class="btn btn-primary btn-xs">Join Meeting</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Schedules -->

      <!-- Recent Activities -->
      <div class="col-xxl-4 col-xl-6 d-flex">
        <div class="card flex-fill">
          <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
            <h5 class="mb-2">Recent Activities</h5>
            <a href="activity.html" class="btn btn-light btn-md mb-2">View All</a>
          </div>
          <div class="card-body">
            <div class="recent-item">
              <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center w-100">
                  <a href="javscript:void(0);" class="avatar flex-shrink-0">
                    <img src="assets/img/users/user-38.jpg" class="rounded-circle" alt="img" />
                  </a>
                  <div class="ms-2 flex-fill">
                    <div class="d-flex align-items-center justify-content-between">
                      <h6 class="fs-medium text-truncate">
                        <a href="javscript:void(0);">Matt Morgan</a>
                      </h6>
                      <p class="fs-13">05:30 PM</p>
                    </div>
                    <p class="fs-13">
                      Added New Project <span class="text-primary">HRMS Dashboard</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="recent-item">
              <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center w-100">
                  <a href="javscript:void(0);" class="avatar flex-shrink-0">
                    <img src="assets/img/users/user-01.jpg" class="rounded-circle" alt="img" />
                  </a>
                  <div class="ms-2 flex-fill">
                    <div class="d-flex align-items-center justify-content-between">
                      <h6 class="fs-medium text-truncate">
                        <a href="javscript:void(0);">Jay Ze</a>
                      </h6>
                      <p class="fs-13">05:00 PM</p>
                    </div>
                    <p class="fs-13">Commented on Uploaded Document</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="recent-item">
              <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center w-100">
                  <a href="javscript:void(0);" class="avatar flex-shrink-0">
                    <img src="assets/img/users/user-19.jpg" class="rounded-circle" alt="img" />
                  </a>
                  <div class="ms-2 flex-fill">
                    <div class="d-flex align-items-center justify-content-between">
                      <h6 class="fs-medium text-truncate">
                        <a href="javscript:void(0);">Mary Donald</a>
                      </h6>
                      <p class="fs-13">05:30 PM</p>
                    </div>
                    <p class="fs-13">Approved Task Projects</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="recent-item">
              <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center w-100">
                  <a href="javscript:void(0);" class="avatar flex-shrink-0">
                    <img src="assets/img/users/user-11.jpg" class="rounded-circle" alt="img" />
                  </a>
                  <div class="ms-2 flex-fill">
                    <div class="d-flex align-items-center justify-content-between">
                      <h6 class="fs-medium text-truncate">
                        <a href="javscript:void(0);">George David</a>
                      </h6>
                      <p class="fs-13">06:00 PM</p>
                    </div>
                    <p class="fs-13">Requesting Access to Module Tickets</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="recent-item">
              <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center w-100">
                  <a href="javscript:void(0);" class="avatar flex-shrink-0">
                    <img src="assets/img/users/user-20.jpg" class="rounded-circle" alt="img" />
                  </a>
                  <div class="ms-2 flex-fill">
                    <div class="d-flex align-items-center justify-content-between">
                      <h6 class="fs-medium text-truncate">
                        <a href="javscript:void(0);">Aaron Zeen</a>
                      </h6>
                      <p class="fs-13">06:30 PM</p>
                    </div>
                    <p class="fs-13">Downloaded App Reportss</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="recent-item">
              <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center w-100">
                  <a href="javscript:void(0);" class="avatar flex-shrink-0">
                    <img src="assets/img/users/user-08.jpg" class="rounded-circle" alt="img" />
                  </a>
                  <div class="ms-2 flex-fill">
                    <div class="d-flex align-items-center justify-content-between">
                      <h6 class="fs-medium text-truncate">
                        <a href="javscript:void(0);">Hendry Daniel</a>
                      </h6>
                      <p class="fs-13">05:30 PM</p>
                    </div>
                    <p class="fs-13">Completed New Project <span>HMS</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Recent Activities -->

      <!-- Birthdays -->
      <!-- <div class="col-xxl-4 col-xl-6 d-flex"> -->
      <div class="col-xxl-4 col-xl-6 d-flex align-items-start">
        <div class="card flex-fill">
          <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
            <h5 class="mb-2">Birthdays</h5>
            <a
              *ngIf="
                todayBirthdays.length !== 0 ||
                tomorrowBirthdays.length !== 0 ||
                upcomingBirthdays.length !== 0
              "
              [routerLink]="eps.event.birthdaysPath"
              class="btn btn-light btn-md mb-2"
              >View All</a
            >
          </div>
          <ng-container
            *ngIf="
              todayBirthdays.length !== 0 ||
                tomorrowBirthdays.length !== 0 ||
                upcomingBirthdays.length !== 0;
              else noRecords
            "
          >
            <div class="card-body pb-1">
              <h6 *ngIf="todayBirthdays.length !== 0" class="mb-2">Today</h6>

              <div
                *ngFor="let user of todayBirthdays"
                class="bg-light p-2 border border-dashed rounded-top mb-3"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <span class="avatar">
                      <!-- If avatar exists, show image -->
                      <img
                        *ngIf="user.picture; else noAvatar"
                        [src]="apiEndpoint + '/uploads/' + user.picture"
                        class="rounded-circle border border-2"
                        alt="img"
                      />

                      <!-- Fallback: first letter of user name -->
                      <ng-template #noAvatar>
                        <span
                          class="avatar avatar-sm online rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white"
                          style="width: 32px; height: 32px"
                        >
                          {{ user.firstName.charAt(0) }}
                        </span>
                      </ng-template>
                    </span>
                    <div class="ms-2 overflow-hidden">
                      <h6 class="fs-medium">{{ user.firstName }} {{ user.lastName }}</h6>
                      <p class="fs-13">
                        {{ user.designation?.designationName || '—' }}
                      </p>
                    </div>
                  </div>
                  <button class="btn btn-secondary btn-xs">
                    <i class="ti ti-cake me-1"></i>Send
                  </button>
                </div>
              </div>
              <h6 *ngIf="tomorrowBirthdays.length !== 0" class="mb-2">Tomorrow</h6>

              <div
                *ngFor="let user of tomorrowBirthdays"
                class="bg-light p-2 border border-dashed rounded-top mb-3"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <span class="avatar">
                      <img
                        *ngIf="user.picture; else noAvatar"
                        [src]="apiEndpoint + '/uploads/' + user.picture"
                        class="rounded-circle border border-2"
                        alt="img"
                      />

                      <!-- Fallback: first letter of user name -->
                      <ng-template #noAvatar>
                        <span
                          class="avatar avatar-sm online rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white"
                          style="width: 32px; height: 32px"
                        >
                          {{ user.firstName.charAt(0) }}
                        </span>
                      </ng-template>
                    </span>
                    <div class="ms-2 overflow-hidden">
                      <h6 class="fs-medium">{{ user.firstName }} {{ user.lastName }}</h6>
                      <p class="fs-13">{{ user.designation?.designationName || '—' }}</p>
                    </div>
                  </div>
                  <button class="btn btn-secondary btn-xs">
                    <i class="ti ti-cake me-1"></i>Send
                  </button>
                </div>
              </div>

              <h6 *ngIf="upcomingBirthdays.length !== 0" class="mb-2">Upcoming</h6>

              <div
                *ngFor="let user of upcomingBirthdays"
                class="bg-light p-2 border border-dashed rounded-top mb-3"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <span class="avatar">
                      <img
                        *ngIf="user.picture; else noAvatar"
                        [src]="apiEndpoint + '/uploads/' + user.picture"
                        class="rounded-circle border border-2"
                        alt="img"
                      />

                      <!-- Fallback: first letter of user name -->
                      <ng-template #noAvatar>
                        <span
                          class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                          style="width: 40px; height: 40px"
                        >
                          {{ user.firstName.charAt(0) }}
                        </span>
                      </ng-template>
                    </span>

                    <div class="ms-2 overflow-hidden">
                      <h6 class="fs-medium d-flex align-items-center gap-2">
                        {{ user.firstName }} {{ user.lastName }}

                        <!-- 📅 Date Badge -->
                        <span class="badge bg-soft-primary text-primary fs-10">
                          {{ formatBirthday(user.birthdate) }}
                        </span>
                      </h6>

                      <p class="fs-13">
                        {{ user.designation?.designationName || '—' }}
                      </p>
                    </div>
                  </div>

                  <button class="btn btn-secondary btn-xs">
                    <i class="ti ti-cake me-1"></i>Send
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #noRecords>
            <div class="text-center">Record not available</div>
          </ng-template>
        </div>
      </div>
      <!-- </div> -->
      <!-- /Birthdays -->
      <!-- Employees -->
      <div class="col-xxl-12 d-flex">
        <div class="card flex-fill">
          <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
            <h5 class="mb-2">Employees</h5>
            <div class="dropdown mb-2">
              <a
                href="javascript:void(0);"
                class="btn btn-white border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-calendar me-1"></i>{{ selectedFilterLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    class="dropdown-item rounded-1"
                    (click)="changeFilter('month', 'employees by department')"
                    >This Month</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-item rounded-1"
                    (click)="changeFilter('week', 'employees by department')"
                    >This Week</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-item rounded-1"
                    (click)="changeFilter('lastWeek', 'employees by department')"
                    >Last Week</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-item rounded-1"
                    (click)="changeFilter('year', 'employees by department')"
                    >This Year</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="card-body">
            <div>
              <apx-chart
                *ngIf="chartOptions"
                [series]="chartOptions.series"
                [chart]="chartOptions.chart"
                [xaxis]="chartOptions.xaxis"
                [yaxis]="chartOptions.yaxis"
                [stroke]="chartOptions.stroke"
                [markers]="chartOptions.markers"
                [dataLabels]="chartOptions.dataLabels"
                [colors]="chartOptions.colors"
              >
              </apx-chart>
            </div>

            <div class="fs-13 mb-2">
              <i class="ti ti-circle-filled me-2 fs-8 text-primary"></i>
              <span>
                Employees {{ thisLabel }} :
                <span class="text-success">{{ thisPeriodCount }}</span>
              </span>

              <div>
                <i class="ti ti-circle-filled me-2 fs-8 text-primary"></i>
                <span>
                  Employees {{ lastLabel }} :
                  <span class="text-success">{{ lastPeriodCount }}</span>
                </span>
              </div>
            </div>

            <p class="fs-13" *ngIf="increasePercentage !== null">
              <i class="ti ti-circle-filled me-2 fs-8 text-primary"></i>

              Number of Employees <span>{{ trendText }}</span> by

              <span
                class="fw-bold"
                [ngClass]="{
                  'text-success': trendText === 'increased',
                  'text-danger': trendText === 'decreased',
                  'text-muted': trendText === 'not changed'
                }"
              >
                {{ trendText === 'increased' ? '+' : trendText === 'decreased' ? '-' : '' }}
                {{ increasePercentage }}%
              </span>

              from {{ lastLabel }}
            </p>
          </div>
        </div>
      </div>
      <!-- /Employees -->
    </div>
  </div>

  <!-- <div class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
      <p class="mb-0">2014 - 2025 &copy; SmartHR.</p>
      <p>Designed &amp; Developed By <a href="javascript:void(0);" class="text-primary">Dreams</a></p>
    </div> -->
</div>
<!-- /Page Wrapper -->
